import { inReviewStatuses } from '@thesavingsgroup/constants/inReviewStatuses';
import { ChecklightSessionStatus } from '@thesavingsgroup/enums/ChecklightSessionStatus';

export const activeStatuses = [
  ...inReviewStatuses,
  ChecklightSessionStatus.APPLICANT_COMPLETE,
  ChecklightSessionStatus.CO_APPLICANT_COMPLETE,
  ChecklightSessionStatus.SELECTED_OFFER,
];
